import API from '../../sunwiseAPI';
const ENTITY = 'companies-currencies';

export const filterItems = (companyId) =>
    API.get(`/api/v1/public/${ENTITY}/`, {
        params: { company: companyId },
    });
